import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { environment } from '../../environments/environment';
export interface BusinessLogo { path:string; width:number; height:number; updated_at:string; }
@Injectable({providedIn:'root'})
export class BusinessLogoService {
  private readonly url=`${environment.baseUrl}/api/v1/business-logo`;
  private readonly publicHttp:HttpClient;
  constructor(private http:HttpClient,backend:HttpBackend) {this.publicHttp=new HttpClient(backend);}
  get() {return this.http.get<{data:BusinessLogo|null}>(this.url).pipe(map(r=>r.data));}
  publicLogo(tenantId:number|string) {return this.publicHttp.get<{data:BusinessLogo|null}>(`${this.url}/public/${tenantId}`).pipe(map(r=>r.data));}
  upload(file:File) {const form=new FormData();form.append('file',file);return this.http.put<{data:BusinessLogo}>(this.url,form).pipe(map(r=>r.data));}
  remove() {return this.http.delete<void>(this.url);}
  imageUrl(path:string|null|undefined):string|null {
    return path && /^\/api\/v1\/business-logo\/public\/[1-9][0-9]*\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\.png$/i.test(path)
      ? `${environment.baseUrl}${path}` : null;
  }
}
